import { ITopicFilterState, TopicFilterNames } from '../shared';

/**
 * This function counts all of the active filter names that are NOT undefined in the given filters instance
 * @param filters The redux filter instance that contains ALL the filters
 * @param activeFilters The filter names for the currently active topic
 */
const getFilterCount = (
  filters: ITopicFilterState,
  activeFilters?: TopicFilterNames[]
): number => {
  if (!activeFilters) {
    return 0;
  }
  return Object.keys(filters).reduce((acc: any, name: string) => {
    if (
      activeFilters.includes(name as TopicFilterNames) &&
      filters[name as TopicFilterNames]
    ) {
      acc++;
    }
    return acc;
  }, 0);
};

export default getFilterCount;
